import { createSlice, createAction } from "@reduxjs/toolkit";

import { ItemFiltersModel } from "../model/item";

import { RootState } from "../store/store";

export const resetItemFilter = createAction("itemFilter/reset");

type SliceState = { value: ItemFiltersModel };
const initialState = {
  value: {
    suppliers: [],
    itemgroups: [],
    itemstatus: [],
    showOnlyItemInCart: false,
  },
} as SliceState;

export const itemFilterSlice = createSlice({
  name: "itemFilter",
  initialState,
  reducers: {
    updateFilter: (state, action) => {
      state.value = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetItemFilter, (n) => {
      return initialState;
    });
  },
});

export const { updateFilter } = itemFilterSlice.actions;

export const getItemFilter = (state: RootState) => state.itemFilter.value;

export default itemFilterSlice.reducer;
